<template>
  <div class="wt-highlight-presets wt2-dropdown" :class="{ '-open': isOpen }">
    <button class="wt-button hollow-dark" @click="toggleMenu">
      <span>Select Highlight</span>
      <i v-if="isOpen" class="wticon wticon-chevron-up" />
      <i v-else class="wticon wticon-chevron-down" />
    </button>

    <ul class="-list" :style="listStyle">
      <li
        v-for="preset in presets"
        :key="preset.code"
        class="-item"
        :style="itemStyle"
        @click="selectItem($event, preset)"
      >
        <img
          v-if="preset.icon"
          class="-icon"
          :src="mixinSrc(preset.icon)"
          alt
        />
        <div
          v-else
          class="-colour"
          :style="{
            visible: preset.color ? 'visible' : 'hidden',
          }"
        >
          <colour-icon :colour="preset.color" />
        </div>
        <div v-text="preset.name" />
        <div class="-code" v-text="preset.code" />
      </li>
    </ul>
  </div>
</template>

<script>
import ColourIcon from './FieldText.colourIcon.vue';

export default {
  components: {
    ColourIcon,
  },
  props: {
    presets: { type: Array, required: true },
    itemHeight: { type: Number, default: 36 },
    numItems: { type: Number, default: 8 },
  },

  beforeDestroy() {
    document.removeEventListener('click', this.$_clickOutside);
    app.keyboardAccessibility.remove(this.guid);
  },

  mounted() {
    document.addEventListener('click', this.$_clickOutside);
  },

  data() {
    return {
      guid: app.guid(),
      isOpen: false,
      kaHandlers: [
        {
          on: 'keydown',
          key: $.ui.keyCode.ESCAPE,
          run: () => {
            this.isOpen = false;
          },
        },
      ],
    };
  },

  watch: {
    isOpen() {
      if (this.isOpen) {
        app.keyboardAccessibility.add(this.guid, this.kaHandlers);
        this.$emit('opened');
      } else {
        app.keyboardAccessibility.remove(this.guid);
      }
    },
  },

  computed: {
    listStyle() {
      const height = this.itemHeight * this.numItems;
      return {
        maxHeight: `${height}px`,
      };
    },

    itemStyle() {
      return {
        height: `${this.itemHeight}px`,
      };
    },
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },

    selectItem(e, preset) {
      this.isOpen = false;
      this.$emit('applyPreset', preset);
    },

    $_clickOutside(e) {
      const isAttached = document.body.contains(e.target);
      const isInside = this.$el.contains(e.target);
      if (isAttached && !isInside) {
        this.isOpen = false;
      }
    },
  },
};
</script>
